import axios from "../utils/axios";

export const getHome = async (slug) => {
    if (!slug) {
        throw new Error("Slug is required to fetch home data");
    } else {
        const { data } = await axios.get(`/user/store/${slug}`);
        return data;
    }
};